<template>
  <div class="js-footer d-flex align-items-center justify-content-center">
    <img class="logo" src="/static/img/index/logo-only.png" alt="">
    <div class="d-flex flex-column align-items-start ml-2">
      <p class="mb-2 font-weight-bold font-10">{{webTitle}}</p>
      <p class="mb-0 font-10">{{ webSmallTitle }}</p>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "littleFooter",
  computed: {
    ...mapState({
      webTitle: state => state.webTitle,
      webSmallTitle: state => state.webSmallTitle,
    })
  }
}
</script>

<style scoped lang="scss">

.js-footer {
  height: 5rem;
  background: #eeeeee;

  .logo {
    width: 2rem;
    height: 2rem;
  }
}
</style>
